export const validateEmail = (email: string) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_NUMBER_REGEX = /\d/;
export const PASSWORD_SPECIAL_CHAR_REGEX = /[^A-Za-z0-9\s]/;
export const PASSWORD_UPPERCASE_REGEX = /[A-Z]/;
export const PASSWORD_LOWERCASE_REGEX = /[a-z]/;

export const validatePassword = (password: string) => {
  return (
    password.length >= PASSWORD_MIN_LENGTH &&
    PASSWORD_NUMBER_REGEX.test(password) &&
    PASSWORD_SPECIAL_CHAR_REGEX.test(password) &&
    PASSWORD_UPPERCASE_REGEX.test(password) &&
    PASSWORD_LOWERCASE_REGEX.test(password)
  );
};

export const hasPasswordError = (password: string) => password.length > 0 && !validatePassword(password);
